

import React from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import { nanoid } from 'nanoid'
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import FormBuilder, { IMedAppFormField } from '../../../form';
import { Admin } from '../../../../models';
import { required, minLength, email } from '../../../form/utils/validations';
import { createModel } from '../../store/actions';
import { selectCreatingModel } from '../../store/selectors';
import LinearProgress from '@mui/material/LinearProgress';

const AdminCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const AdminCreateReduxForm = reduxForm<any, any>({
    form: 'admin-create',
})(AdminCreateForm);


const AdminCreate: React.FC<{
    admin?: Admin
}> = ({ admin }) => {
 const password = nanoid(10);
    const dispatch = useDispatch();
    const creating = useSelector(selectCreatingModel('admin'));

    const fields: IMedAppFormField[] = React.useMemo (() => ([
        {
            name: 'Email',
            label: 'Email Address',
            type: 'email',
            validate: [email],

        },
        {
            name: 'Name',
            label: 'Full Name',
            type: 'text',
            validate: [required, minLength(2)],

        },

        {
            name: 'divider',
        
            type: 'text',
            variant: 'divider',
        },
        {
            name: 'Password',
            label: 'Admin Password',
            type: 'text',
            inputExtras: {
                disabled: true,
                value: password
            },
            

        },

 
        
    ]), [password]);


    
    const handleSubmit = (value: any) => {
        const data = {...value, Status: 1, Password: password}

        dispatch(createModel({
            model: data,
            modelName: 'admin',
        }))
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                {(creating) && <LinearProgress />}
                <Typography variant="h6">Create Admin</Typography>
                <AdminCreateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default AdminCreate;